import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useClerk, useUser } from '../lib/auth';

/** Personal payment records are separate from the team's entitlement. */
interface PersonalSubscriptionSummary { subscriptionItems: Array<{ plan: { isDefault: boolean } }> }

export function usePersonalSubscription(): UseQueryResult<PersonalSubscriptionSummary, Error> {
  const clerk = useClerk();
  const { user } = useUser();
  return useQuery<PersonalSubscriptionSummary>({
    queryKey: ['personal-subscription', user?.id],
    enabled: Boolean(user?.id && clerk.billing),
    queryFn: async () => {
      if (!clerk.billing) throw new Error('Billing is unavailable');
      const subscription = await clerk.billing.getSubscription({});
      // Offline, clerk-js returns a subscription with no fields set instead of
      // rejecting; a success here crashed the dashboard header (2026-10-27).
      if (!Array.isArray(subscription?.subscriptionItems)) throw new Error('Subscription read returned no items');
      return subscription;
    },
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
